var React = require('react');

function Email (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor"},[React.createElement("path",{"d":"M15.396 12.98l7.847 7.587A1.992 1.992 0 0122 21H2c-.47 0-.902-.162-1.243-.433l7.846-7.587 3.05 2.949.077.061a.5.5 0 00.54 0l.078-.061 3.048-2.949zM.297 4.95l7.586 7.334L.15 19.762A1.994 1.994 0 010 19V6c0-.385.109-.745.297-1.05zm23.406.001c.188.305.297.664.297 1.049v13c0 .27-.053.526-.15.761l-7.734-7.477 7.587-7.333z","key":0}),React.createElement("path",{"d":"M22 4c.357 0 .692.093.982.257L12 14.873 1.02 4.257A1.99 1.99 0 012 4h20z","key":1})]));
}

Email.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Email;

Email.default = Email;
